import { Component, OnInit, Optional, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { DeviceService } from '@mpt-fo/common/core/services/device.service';
import { StringHelper } from '@mpt-fo/common/core/helpers/strings.helper';
import { BiometricType, MobileWebViewService } from '@mpt-fo/common/core/services/mobile-web-view.service';
import { MobileDelegateService } from '@mpt-fo/common/core/services/mobile-delegate.service';
import { DeviceHelperService } from '@mpt-fo/common/core/services/device-helper.service';
import { OnboardingService } from '@mpt-fo/common/core/services/onboarding.service';
import { DataLayerService } from '@mpt-fo/common/core/services/data-layer-service.service';
import { AccountCreationData } from'@mpt-fo/common/core/models/login.model';
import { DelegateType } from '@mpt-fo/common/shared/models/utility.model';
import { ModalService } from '@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service';
import { initializeDatalayer } from '@mpt-fo/common/shared/models/data.layer.model';

@Component({
	selector: 'app-register-biometric',
	templateUrl: './register-biometric.component.html',
	styleUrls: ['./register-biometric.component.scss'],
})
export class RegisterBiometricComponent implements OnInit {
	isFingerPrint: boolean;
	submitting: boolean;
	errorMessage: string;
	deviceInfo = null;
	runningModal: NzModalRef;
	readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};

	constructor(
		@Optional() private modal: NzModalRef,
		private deviceService: DeviceService,
		private mobileWebViewService: MobileWebViewService,
		private delegateService: MobileDelegateService,
		private deviceHelper: DeviceHelperService,
		private onboardingService: OnboardingService,
		private dataLayerHelper: DataLayerService,
		private modalService: ModalService
	) {}

	ngOnInit(): void {
        this.modal.componentInstance = { ...this.modal.componentInstance, ...this.nzModalData };
		this.isFingerPrint = this.mobileWebViewService.getBiometricType() === BiometricType.FINGER_PRINT;
		this.deviceInfo = this.deviceHelper.getDeviceInformation();
	}

	setUpBiometric() {
		const signupData: AccountCreationData = this.onboardingService.getSignUpFormData();
		const payload = this.getDataLayer('signup_biometrics_setup_initiated', '', signupData);
		this.dataLayerHelper.logEvent(payload);
		this.submitting = true;
		this.delegateService
			.setDelegateData(DelegateType.authenticateWithBiometric, 'SetUp')
			.then((res) => {
				payload.event = 'signup_biometrics_setup_success';
				this.dataLayerHelper.logEvent(payload);
				this.enableBiometric(res);
			})
			.catch((error) => {
				this.submitting = false;
				payload.error_message = StringHelper.getErrorMessageHttpErrorResponse(error);
				const getMixpanelMessage = StringHelper.getMixpanelErrorMessage(error);
				payload[`api_error_message`] = getMixpanelMessage;
				payload[`api_error_code`] = error?.status;
				payload.event = 'Signup_device_registered_failed';
				this.dataLayerHelper.logEvent(payload);
				this.cancelModal();
			});
	}

	deleteBiometricKey() {
		this.delegateService
			.getDelegateData(DelegateType.deleteBiometricKey)
			.then(() => {})
			.catch((error) => {});
	}

	cancelModal() {
		if (!this.submitting) {
			this.callBack();
		}
	}

	callBack() {
		this.modal.componentInstance.callback();
	}

	enableBiometric(biometricKey) {
		const deviceInformation = this.deviceHelper.getDeviceInformation();
		const params = {
			biometricKey,
			deviceIdentifier: deviceInformation?.deviceUniqueIdentifier,
		};
		this.deviceService
			.setBiometrics(params)
			.then(() => {
				this.errorMessage = null;
				this.mobileWebViewService.setRegisterBiometric(false);
				this.callBack();
			})
			.catch((error) => {
				this.errorMessage = StringHelper.getErrorMessageHttpErrorResponse(error);
				this.submitting = false;
				this.deleteBiometricKey();
			});
	}

	getDataLayer(event, username, data, message = '') {
		const payload = initializeDatalayer(event);
		(payload.phone_number = data?.phoneVerificationFormData?.phoneNumber),
			(payload.email = data?.phoneVerificationFormData?.email),
			(payload.step = 'Register Biometric');
		payload.error_message = message;
		payload.user_name = username;
		return payload;
	}
}
